module.exports = __webpack_public_path__ + "static/media/footer-menu-hexagon.b99eb119.svg";